import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/** Compact theme toggle pill — appears in DashboardLayout, PortalLayout, and on the public Login/Landing pages. */
export default function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-toggle"
            aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
            title={`Switch to ${isDark ? "light" : "dark"} mode`}
            className={`inline-flex items-center justify-center w-9 h-9 border border-border hover:border-primary hover:text-primary text-muted-foreground transition-colors ${className}`}>
            {isDark ? <Sun className="w-4 h-4" strokeWidth={1.5} /> : <Moon className="w-4 h-4" strokeWidth={1.5} />}
        </button>
    );
}
